// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.1_webpack@5.91.0_@swc+core@1.15.18_esbuild@0.20.2_webpack-cli@5.1.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sell-tickets-container {
  height: calc(100vh - 96px);
}

.footer-button {
  width: 100%;
  height: 56px;
}
@media (min-width: 768px) {
  .footer-button {
    width: auto;
    display: inline-block;
    height: 56px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/sell-tickets/style.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;AAAE;EAJF;IAKI,WAAA;IACA,qBAAA;IACA,YAAA;EAGF;AACF","sourcesContent":[".sell-tickets-container {\n  height: calc(100vh - 96px);\n}\n.footer-button {\n  width: 100%; // Full width on mobile\n  height: 56px;\n\n  @media (min-width: 768px) { // Desktop and above\n    width: auto; // Adjust based on text size\n    display: inline-block;\n    height: 56px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
